// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function reorderSavedView(ydb: Database, viewId: string, newIndex: number): void {
  ydb.mutate((db) => {
    db.reorderView(viewId, newIndex);
  });
}
